<!-- Created by henian.xu on 2020/11/20. -->

<template>
    <Page>
        <Container>
            <List
                v-if="listData && listData.length"
                class="ma-t"
                padding
                margin
            >
                <CertificateReceiveItem
                    v-for="item in listData"
                    :key="item.id"
                    :dataset="item"
                    @click="()=>{onItem(item)}"
                ></CertificateReceiveItem>
            </List>

            <div class="pa-a tc-minor">
                <div>补证申请说明:</div>
                <div>当前仅支持3年内通过本系统报名证考新培或复审，并成功通过考试的学员，才能通过系统申请补换证申请。</div>
            </div>

            <Pagination
                ref="infinite"
                :disabled="paginationDisabled"
                @load="onload"
            />

            <CertCat
                v-show="false"
                p-id="1"
                ref="certCatPicker"
                choose-last-item
                @input="onCertCatInput"
            ></CertCat>
        </Container>

        <PageBar
            position="bottom"
        >
            <XButton
                class="item"
                label="新增补证申请"
                theme="success"
                @click="onAdd"
            ></XButton>
        </PageBar>
    </Page>
</template>

<script>
import { paginationMixin } from 'mixins';
import CertificateReceiveItem from './_CertificateReceiveItem';
import { state } from './store';

export default {
    name: 'ListPage',
    components: { CertificateReceiveItem },
    mixins: [paginationMixin],
    data() {
        return {
            paginationDisabled: true,
        };
    },
    methods: {
        async getListData(params) {
            const res = await this.$api.Member.Ce.SupplementApply.applyList(params);
            console.log(res.data);
            this.listData.push(...res.data);
            return res;
        },
        onAdd() {
            const { certCatPicker } = this.$refs;
            if (!certCatPicker) return;
            certCatPicker.open();
        },
        async onCertCatInput(val) {
            const { data: skuId } = await this.$api.Member.Gd.Goods.searchSku({
                goodsType: '4',
                certExamType: '4',
                certCatId: val,
            });

            const { data, code, success, msg } = await this.$api.Member.Ex.Order.buyNowConfirm(
                {
                    skuId,
                    quantity: 1,
                },
                {
                    isHandleError: true,
                },
            );
            if (!success) {
                if (code === 1200) {
                    await this.$messageBox.confirm(msg, '温馨提示', {
                        confirmBtnText: '立即实名',
                    });
                    this.$router.push(`/user/idCardAuth`);
                } else {
                    this.$messageBox.alert(msg);
                }
                return;
            }
            this.$router.push(`/order/new/${data.uuid}`);
            console.log('onCertCatInput', val, skuId);
        },
        async onItem(item) {
            this.$router.push(`/supplementApply/applyMaterials/${item.id}`);
        },
    },
    created() {
        this.refreshList();
    },
    activated() {
        if (state.needRefresh) {
            this.refreshList();
        }
    },
};
</script>

<style lang="scss">
</style>
